const currencyCookieKey = 'user-currency'

export const useCurrency = () => {
  const { locale } = useLocale()

  const cookie = useCookie(currencyCookieKey, {
    default: () => (locale.value === 'en_GB' ? 'EUR' : 'CZK'),
  })
  const currency = useState('currency', () => cookie.value)

  watch(
    currency,
    () => {
      cookie.value = currency.value
    },
    { deep: true }
  )

  const changeCurrency = (c: string) => {
    currency.value = c
  }

  return {
    currency,
    changeCurrency,
  }
}
